import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../utils/createAuthProvider';
import { alertMessage } from '../utils/alertMessage';
import { authRoute } from '../constants/pathname';
import getDashboardStyle from '../utils/getDashboardStyle';
import PosTerminal from '../views/pos/PosTerminal';

/**
 * Full-screen POS / cashier terminal for iPad ordering.
 *
 * This is a top-level route (not under the dashboard shell) so it renders
 * full-screen with no sidebar/tabs. Auth is guarded here the same way the
 * dashboard does it.
 */
const Pos = () => {
  const history = useHistory();
  const auth = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!auth.isLogged) {
      history.push(authRoute.login);
      alertMessage('error', t('login.alerts.loginRequired'));
    }
  }, [history, auth, t]);

  // POS is outside the dashboard tab system, so set the browser tab title here
  useEffect(() => {
    document.title = `${t('pos.title')} - ${t(getDashboardStyle().title)}`;
  }, [t]);

  return <PosTerminal />;
};

export default Pos;
